import React, { useEffect, useContext, useState } from 'react'
import { useParams, Link } from "react-router-dom";
import { DefaultContext } from '../../context/context_default';
import { useNavigate } from "react-router-dom";
import { Card } from '../listaCards/componentes/card';
import './styles.css';

import imgBG from "../../assets/imagens/bg_card.jpg";
import imgIgn from "../../assets/imagens/ign.png";
import imgVerbus from "../../assets/imagens/verbus.png";
import imgKarma from "../../assets/imagens/karma.png";
import imgGnos from "../../assets/imagens/gnos.png";
import imgOmna from "../../assets/imagens/omna.png";
import imgDnama from "../../assets/imagens/dnama.png";

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
// import imgIgn from "../../assets/imagens/ign.png";
// require('../../assets/imagens/ign.png')
const CardDetail = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const [card, setCard] = useState(null)
    const [efeito, setEfeito] = useState(null)
    const [imageLoaded, setImageLoaded] = useState(false);
    const [img_atual, setImageAtual] = useState('');
    const [img_next, setImageNext] = useState('');
    const [cardsSemelhantes, setCardsSemelhantes] = useState([])
    const [index_img, setIndex_img] = useState(0)
    const [index_img_next, setIndex_img_next] = useState(1)
    const [count_img, setCount_img] = useState(0)

    const [animate, setAnimate] = useState(false);
    const [animationStep, setAnimationStep] = useState(0);
    const [isClicked, setIsClicked] = useState(false);

    const [contadorSemelhante, setContadorSemelhante] = useState(8)
    const {
        getSubTipos,
        subTipos,
        tipos,
        getTipos,
        getPalavrasChave,
        palavraChave,
        getFortunas,
        getCausas,
        causas,
        fortunas,
        getRaridade,
        raridades,
        listCards,
        getListCards,
        is_descktop,
        filterFetch,
        HTMLRenderer,
        replaceText
    } = useContext(DefaultContext);

    useEffect(() => {
        // getSubTipos();
        // getTipos();
        // getPalavrasChave();
        // getFortunas();
        // getCausas();
        // getRaridade();
        // getListCards();

        // console.log(id, listCards)
        setCard(listCards?.find(e => e?.id == id))
    }, [])

    useEffect(() => {
        // console.log(listCards.find(e => e.id == id))
        setCard(listCards?.find(e => e?.id == id))
    }, [listCards])

    useEffect(() => {

        if (card) {
            setEfeito(replaceText(card?.efeito))
        }
        setCardsSemelhantes(listCards?.sort((a, b) => contarElementosIguais(card, b) - contarElementosIguais(card, a)));

        setImageAtual(card?.url_img)
        setCount_img(card?.url_img_alternativa?.length)
    }, [card])

    const NextImg = () => {
        if (count_img > 0) {
            var index_img_atual = index_img + 1

            if (index_img_atual == 0) {
                setImageAtual(card?.url_img_alternativa[index_img_atual - 1])
                setIndex_img(index_img_atual)
            }
            else if (index_img_atual > 0 && index_img_atual <= count_img) {
                setImageAtual(card?.url_img_alternativa[index_img_atual - 1])
                setIndex_img(index_img_atual)
            }
            else {
                setImageAtual(card?.url_img)
                setIndex_img(0)
            }


        }
    }

    const BackImg = () => {
        if (count_img > 0) {
            var index_img_atual = index_img - 1
            if (index_img_atual < 0) {
                setImageAtual(card?.url_img_alternativa[count_img - 1])
                setIndex_img(count_img)

            }
            else if (index_img_atual == 0) {
                setImageAtual(card?.url_img)
                setIndex_img(index_img_atual)
            }

            else if (index_img_atual > 0 && index_img_atual <= count_img) {
                setImageAtual(card?.url_img_alternativa[index_img_atual - 1])
                setIndex_img(index_img_atual)
            }



        }
    }

    const handleImageLoad = () => {
        setImageLoaded(true);

        setIsClicked(true);
        setTimeout(() => setIsClicked(false), 200); // Duration of the animation
        // setImageLoaded(false);

    };
    const replacesAll = (string, search, replace) => {
        return string?.split(search).join(replace);
    }

    function contarElementosIguais(jsonReferencia, jsonComparacao) {
        let contador = 0;

        for (const chave in jsonReferencia) {

            if (chave === "efeito" && jsonReferencia["efeito"] && jsonReferencia["efeito"].toLowerCase().includes(jsonComparacao["nome"].toLowerCase())) {
                contador += 5;
            }

            else if (chave === "vida" || chave === "p_a" || chave === "custo") {
                contador += compararValorNumerico(jsonReferencia[chave], jsonComparacao[chave]);
            }
            else if (Array.isArray(jsonReferencia[chave])) {
                const arrayReferencia = jsonReferencia[chave];
                const arrayComparacao = jsonComparacao[chave];

                if (arrayReferencia?.length === arrayComparacao?.length &&
                    arrayReferencia.every((valor, index) => valor === arrayComparacao[index])) {
                    contador++;
                }
            } else if (jsonComparacao[chave] === jsonReferencia[chave]) {
                contador++;
            }
        }

        return contador;
    }
    function compararValorNumerico(valorReferencia, valorComparacao) {
        // Ajuste conforme necessário para a relevância desejada
        const diferenca = Math.abs(Number(valorReferencia) - Number(valorComparacao));
        return (1 / (1 + diferenca)) * 2;  // Quanto menor a diferença, maior a relevância
    }


    const estiloDoComponente = {
        WebkitFilter: 'drop-shadow(0px 0px 1px #ffffff52)',
        filter: 'drop-shadow(0px 0px 1px #ffffff52)',

    };
    const estiloDoComponenteCard = {
        WebkitFilter: 'drop-shadow(0px 0px 4px #0f0f0f)',
        filter: 'drop-shadow(0px 0px 4px #0f0f0f)',
    };
    return (
        <div style={{ backgroundImage: `url(${imgBG})`, }} className='h-full w-full bg-cover bg-center flex justify-center md:justify-end items-cente overflow-hidden'>
            <div className={` mr-0 duration-200 bg-slate-700 bg-opacity-[94%] w-full h-full pt-20 transition-all p-2  overflow-y-auto  scrollbar-thin overflow-x-hidden scrollbar-thumb-slate-600  scrollbar-rounded-sm`}>

                <div className='flex flex-col w-full   '>
                    {/* <div>Titulo aqui</div> */}
                    <div className='flex lg:flex-row lg:items-start flex-col  items-center w-full justify-center'>
                        <div className=' max-w-[400px] '>

                            <div className='  relative flex items-center'>


                                {count_img > 0 && (
                                    <div onClick={BackImg} className='absolute left-0 w-10 h-10 bg-opacity-50 cursor-pointer hover:bg-opacity-100 rounded-full mx-1 bg-slate-800 z-10 flex justify-center items-center border border-slate-400 border-opacity-25 group'><ArrowBackOutlinedIcon className='text-white text-opacity-25  group-hover:text-opacity-100'></ArrowBackOutlinedIcon></div>
                                )}
                                {count_img > 0 && (
                                    <div onClick={NextImg} className='next absolute right-1 bg-opacity-50 cursor-pointer hover:bg-opacity-100 w-10 h-10 rounded-full bg-slate-800 z-10 flex justify-center items-center border border-slate-400 border-opacity-25 group'><ArrowForwardOutlinedIcon className='text-white text-opacity-25  group-hover:text-opacity-100'></ArrowForwardOutlinedIcon></div>
                                )}
                                {count_img > 0 && (
                                    <div className='absolute flex justify-center items-center right-2 top-1 p-2 text-xs bg-opacity-75 rounded-lg  bg-slate-900 z-10 border border-slate-400 border-opacity-25'>{index_img + 1}/{count_img + 1}</div>
                                )}

                                <img
                                    className={`animate-img w-[97%] h-full object-contain top-0 left-0 `}
                                    style={estiloDoComponenteCard}
                                    src={card && imageLoaded && img_atual !== '' ? img_atual : require('../../assets/imagens/back_card.png')}
                                    loading="lazy"
                                    onLoad={handleImageLoad}
                                />

                            </div>

                        </div>
                        {/* <img style={{ width: 20, height: 20 }} src={imgIgn}  ></img> */}
                        <div className='max-w-[400px]  flex flex-col  mt-4  bg-gray-800  p-2 rounded-md ' >
                            <div className='p-3 rounded border border-gray-700 '>
                                <div className='flex space-x-3'>
                                    <div className='flex justify-center items-center h-full'>

                                        {card && causas && card.causa != '' ?
                                            <img style={estiloDoComponente} src={require('../../assets/imagens/' + causas?.find(e => e.id == card?.causa)?.causa + '.png')} class="w-8 h-8 object-cover mr-2" />
                                            // null
                                            : null}
                                        {card && causas && card.causa != '' ? causas?.find(e => e.id == card?.causa)?.causa : null}
                                    </div>
                                    <div className='flex justify-center items-center h-full'>
                                        {card && raridades && card?.raridade != '' ?
                                            <img style={estiloDoComponente} src={require('../../assets/imagens/' + raridades?.find(e => e.id == card?.raridade)?.raridade + '.png')} class="w-8 h-8 object-cover mr-2" />
                                            // null
                                            : null}
                                        {card && raridades && card?.raridade != '' ? raridades?.find(e => e.id == card?.raridade)?.raridade : null}
                                    </div>
                                </div>

                                <div className='w-full border-b border-slate-400 my-6' ></div>
                                {card ?
                                    <div className='flex flex-col'>
                                        <h2 className='font-bold text-2xl '>{card?.nome}</h2>
                                        <div className='flex text-sm'>{card?.tipo?.map(e => tipos?.find(t => t?.id == e)?.tipo + ' ')} / {card?.sub_tipo?.map(e => subTipos?.find(t => t?.id == e)?.tipo + ' ')}</div>
                                    </div> : null
                                }

                                <div className='w-full border-b border-slate-400 my-6' ></div>

                                {efeito ? <HTMLRenderer html={efeito} /> : null}
                                {palavraChave && card && card?.p_c.length > 0 ? <div className='w-full border-b border-slate-400 my-6' ></div> : null}
                                {palavraChave && card ? card?.p_c.map(id => {
                                    return <div className='  text-white  border-l-2 my-2 '>
                                        {/* <div className='p-2'>{palavraChave.find(item => item.id == id).nome}</div> */}
                                        {/* <div className='border-b border-slate-400 '></div> */}
                                        <div className='ml-2  flex'>{<HTMLRenderer html={replaceText('<strong>' + palavraChave?.find(item => item?.id == id)?.nome + '</strong> - ' + palavraChave?.find(item => item?.id == id)?.descricao)} />}</div>
                                    </div>
                                }) : null}
                            </div>
                        </div>
                    </div>
                    <div className='flex items-center px-10 mt-10'>
                        <div className='w-full border-b border-slate-400 my-6' ></div>
                        <div className='min-w-fit px-6'>Cards Relacionados</div>
                        <div className='w-full border-b border-slate-400 my-6' ></div>
                    </div>

                    <div className='flex justify-center mt-10'>
                        {cardsSemelhantes ?
                            <div className='grid md:grid-cols-4 grid-cols-2 w-fit gap-x-0 gap-y-0'>
                                {cardsSemelhantes?.slice(1, contadorSemelhante + 1)?.map(item => <Link to={`/detail/${item?.id}`} onClick={(event) => { if (!event.ctrlKey) { window.location.href = `/detail/${item?.id}`; } }} className='mt-[-45px] p-1'><Card card={item} zoom={false} index={1} columMax={contadorSemelhante} /> </Link>)}

                            </div> : null
                        }


                        {/* <div className='flex'><Card card={card} zoom={false} index={1} columMax={3} /></div> */}

                    </div>
                </div>

            </div>

        </div>

    )
}

export default CardDetail